export default {
  coffeeData: {
    windBreaker: "Mti wa Kuvunja Upepo",
    horticultureInfo: "Mti wa Kilimo cha bustani",
    shadeTree: "Mti wa Kivuli",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
    processingBatchQuality: "Ubora wa Kundi la Usindikaji",
    greenCoffeeQuality: "Ubora wa Kahawa Ijani",
    processType: "Aina ya Mchakato",
    updateWindBreaker: "Sasisha Aina ya Mti wa WindBreaker",
    addWindBreaker: "Ongeza Aina Mpya ya Mti wa WindBreaker",
    updateHorticultureInfo: "Sasisha Aina ya Mti wa HorticultureInfo",
    addHorticultureInfo: "Ongeza Aina Mpya ya Miti ya HorticultureInfo",
    updateShadeTree: "Sasisha kivuliMti Aina ya Mti",
    addShadeTree: "Ongeza Kivuli Kipya Aina ya Mti",
    updateCoffeeVariety: "Sasisha aina ya mti wa kahawa",
    addCoffeeVariety: "Ongeza kahawa Mpya Aina ya Mti",
    deleteVarietyTitle: "Futa Aina",
    deleteVarietyMessage: "Je, una uhakika unataka kufuta Aina mbalimbali?",
    updateCoffeeSpecie: "Sasisha Aina ya Kahawa",
    deleteSpecieTitle: "Futa Aina",
    deleteSpecieMessage: "Je, una uhakika unataka kufuta Spishi?",
    addCoffeeSpecie: "Ongeza aina Mpya ya Kahawa",
    variety: "Tofauti",
    selectVariety: "Chagua Aina",
    selectSpecie: "Chagua Aina",
    deleteCoffeeRecord: "Je, una uhakika unataka kufuta rekodi?",
    deleteCoffeeData: "Futa Data ya Kahawa",
    topicRequired: "Chagua Mada inahitajika",
    coffeeAddSuccess: "Aina ya Kahawa imeongezwa kwa mafanikio.",
    treeTypeSuccess: "Aina ya mti imeongezwa kwa mafanikio.",
    treeTypeUpdateSuccess: "Aina ya mti imesasishwa.",
    coffeeVarietySuccess: "Aina ya kahawa imeongezwa kwa mafanikio.",
    coffeeSpecieSuccess: "Aina ya kahawa imesasishwa.",
    nameRequired: "Jina linahitajika",
    notFound: "Hakuna Data ya Kahawa ya Msimamizi Imepatikana",
  },
  cacaoData: {
    bags: "Mifuko",
    batchVisualIdentification: "Utambuzi wa Visual wa Kikundi",
    boxes: "Masanduku",
    cacao: "Kakao",
    cacaoOverview: "Muhtasari wa Kakao",
    cacaoSpecies: "Aina za Kakao",
    cacaoType: "Aina ya Kakao",
    cacaoVariety: "Aina ya Kakao",
    cacaoWeight: "Uzito wa Kakao",
    deleteCacaoData: "Futa Data ya Kakao",
    deliveryMethod: "Njia ya Uwasilishaji",
    fermentationPercentage: "Asilimia ya Uchachuaji",
    fermetationMethod: "Njia ya Uchachuaji",
    finalWeight: "Uzito wa Mwisho",
    initialWeight: "Uzito wa Awali",
    performance: "Utendaji",
    piles: "Rundo",
    productPricePerKg: "Bei kwa Kila KG",
    productType: "Aina ya Bidhaa",
    productWeight: "Uzito wa Bidhaa",
    registerFermentation: "Sajili Uchachuaji",
    selectPlantation: "Chagua Shamba",
    selectZone: "Chagua Eneo",
    totalPrice: "Jumla ya Bei",
  },
  memberDataSection: {
    import: "Ingiza",
    buyingStation: "Kituo cha Kununua",
    factory: "Kiwanda",
    factories: "Vianda",
    societies: "Vyama",
    factoriesName: "Jina la Kiwanda",
    factoriesProdChart: "Kiwanda cha Ungaji wa Bidhaa",
    factoryInfo: "Maelezo ya Kiwanda",
    factoryDashboard: "Dashibodi ya Kiwanda",
    factoryDashboardPage: {
      title: "Dashibodi ya Kiwanda",
      close: "Funga",
      resetFilters: "Weka Upya Vichujio",
      apply: "Tumia",
      monthlySupplyTrend: "Mwelekeo wa Ugavi wa Kila Mwezi",
      processingEfficiency: "Ufanisi wa Usindikaji",
      funnelChart: "Chati ya Funnel - Ingizo -> Tokeo",
      totalLoss: "Hasara Jumla",
      noTarget: "Hakuna lengo lililowekwa",
      ytdScope: "(YTD {year})",
      operationalEfficiency: "Ufanisi wa Uendeshaji",
      target: "Lengo",
      actual: "Halisi",
      farmerParticipation: "Ushiriki wa Wakulima - Mgawanyo wa Mchango",
      totalInput: "Ingizo Jumla",
      totalOutput: "Tokeo Jumla",
      activeFarmers: "Wakulima Hai",
      rawIntake: "Ingizo Ghafi (Cherry Iliyopokelewa)",
      processing: "Usindikaji (Cherry Iliyosindikwa)",
      output: "Tokeo (Parchment Iliyotolewa)",
      currentPeriod: "Kipindi cha Sasa",
      previousPeriod: "Kipindi Kilichopita",
      volumePerTopFarmers: "Kiasi kwa Wakulima Bora",
      cumulativeImpact: "Athari ya Jumla (%)",
      deliveries: "Uwasilishaji (kg)",
      operational: "Uendeshaji",
      volume: "Kiasi (kg)",
      cumulative: "Jumla (%)",
      to: "hadi",
      ranges: {
        today: "Leo",
        week: "Wiki",
        month: "Mwezi",
        year: "Mwaka",
        all: "Zote",
      },
    },
    continue: "Endelea",
    farmerId: "Kitambulisho cha Mkulima",
    farmerName: "Jina la Mkulima",
    farmerAddress: "Anwani ya Mkulima",
    quality: "Ubora",
    quantity: "Kiasi",
    importAll: "Ingiza Zote",
    importSelected: "Uagizaji Umechaguliwa",
    selectCrop: "Chagua Mazao",
    fileLoaded: "Faili imepakiwa",
    incorrectHeaders: "Vijajuu visivyo sahihi",
    processingBatch: "Kundi la usindikaji",
    purchaseOrder: "Agizo la Ununuzi",
    buyingStationDetails: "Maelezo ya Kituo cha Kununua",
    buyingStationUsers: "Watumiaji wa Kituo cha Kununua",
    activityLog: "Kumbukumbu ya Shughuli",
    startDate: "Tarehe ya Kuanza",
    endDate: "Tarehe ya mwisho",
    purchasingOrder: "Agizo la Ununuzi",
    totalCoffeeCherry: "Jumla ya Cherry ya Kahawa",
    airHumidity: "Unyevu wa Hewa",
    density: "Msongamano",
    temperature: "Halijoto",
    beanMoistureContent: "Maudhui ya Unyevu wa Maharage",
    processType: "Aina ya Mchakato",
    batchRating: "Chagua Ukadiriaji wa Kundi",
    purchaseDate: "Tarehe ya Kununua",
    selectFarmer: "Chagua Mkulima",
    selectFarm: "Chagua Shamba",
    selectPlantation: "Chagua Upandaji miti",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    coffeeCherryQuantity: "Kiasi cha Cherry ya Kahawa",
    coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
    coffeeType: "Aina ya Kahawa",
    pricePerKg: "Bei Kwa Kg",
    processingDone: "Usindikaji Umekamilika",
    processedCoffeeOut: "Kahawa Iliyochakatwa",
    farmer: "Mkulima",
    farm: "Shamba",
    plantation: "Upandaji miti",
    farmers: "Wakulima",
    farmLimitUsed: "Kikomo cha Kilimo Kimetumika",
    phoneNumber: "Nambari ya simu",
    farmSize: "Ukubwa wa Shamba",
    farmLocation: "Shamba/Mahali",
    date: "Tarehe",
    status: "Hali",
    noFarmers: "Hakuna Wakulima Waliopatikana",
    approveReject: "Idhinisha/Kataa",
    farms: "Mashamba",
    crops: "Mazao",
    equipment: "Vifaa",
    noFarms: "Hakuna Mashamba Yaliyopatikana",
    views: "Tazama",
    selectStatus: "Chagua Hali",
    approved: "Imeidhinishwa",
    rejected: "Imekataliwa",
    reject: "Kataa",
    approve: "Idhinisha",
    cancel: "Ghairi",
    add: "Ongeza",
    describeYourReason: "Eleza sababu yako hapa",
    userInformation: "Taarifa za Mtumiaji",
    userFarmRequest: "Ombi la Shamba la Mtumiaji",
    userFarmInformation: "Taarifa za Shamba la Watumiaji",
    activity: "Shughuli",
    activityType: "Aina ya Shughuli",
    farmZone: "Eneo la Shamba",
    farmerView: "Mtazamo wa Mkulima",
    cropType: "Aina ya Mazao",
    cropVarity: "Tofauti ya Mazao",
    area: "Eneo",
    cost: "Gharama",
    geofence: "Geofence",
    map_views: "Mwonekano wa Ramani",
    viewAllFarms: "Tazama Mashamba Yote",
    farmersDetails: "Maelezo ya Mkulima",
    download: "Pakua",
    pOrder: {
      addNew: "Ongeza Mpya",
      viewAll: "Ona Zote",
      selectDate: "Chagua tarehe",
      makeSelection: "Fanya chaguo",
      coffeeType: "Aina ya kahawa",
      enterPrice: "Ingiza bei",
      reqPurchaseDate: "Tarehe ya ununuzi inahitajika",
      reqFarmer: "Mkulima anahitajika",
      reqCoffeeQnty: "Kiasi cha Kahawa ya Cherry kinahitajika",
      reqPrice: "Bei kwa Kilo kinahitajika",
      grandTotal: "JUMLA KUBWA",
      selectDateRange: "Chagua Kipindi cha Tarehe",
      import: "Import",
      purchaseId: "Nunua Idadi",
      purchaseDate: "Tarehe ya Ununuzi",
      farmerName: "Jina la Mkulima",
      quality: "Ubora",
      quantity: "Kiasi",
      pricePerKg: "Bei kwa Kilo",
      selectBuyingStation: "Chagua kituo cha ununuzi",
      searchUser: "tafuta mtumiaji",
    },
    dateOfEntry: "Tarehe ya Kuingia",
    farmActivities: "Shughuli za Shamba",
    farmActivity: "Shughuli ya Shamba",
    farmDetails: "Maelezo ya Shamba",
    farmID: "Kitambulisho cha Shamba",
    farmInformation: "Taarifa za Shamba",
    goalType: "Aina ya Lengo",
    locationAddress: "Anwani ya Mahali",
    ownershipType: "Aina ya Umiliki",
    selectFarmZone: "Chagua Eneo/Shamba",
    showOnMap: "Onyesha kwenye Ramani",
    totalCost: "Gharama Jumla",
    totalFarmArea: "Eneo Jumla la Shamba",
    totalFarmsRegistered: "Jumla ya Mashamba Yalisajiliwa",
    totalSize: "Ukubwa Jumla",
    totalZone: "Jumla ya Eneo",
    zone: "Eneo",
    zones: "Maeneo",
  
    // Buying Station specific translations
    buyingStations: "Vituo vya Ununuzi",
    registerBuyingStation: "Sajili Kituo cha Ununuzi",
    registerFactory: "Sajili Kiwanda",
    loadingFactory: "Inapakia Kiwanda...",
    loadingBuyingStation: "Inapakia Kituo cha Ununuzi...",
    searchBuyingStation: "Tafuta Kituo cha Ununuzi",
    searchFactory: "Tafuta Kiwanda",
    searchSociety: "Tafuta Chama",
    nameAndId: "Jina / Kitambulisho",
    email: "Barua pepe",
    mobileNumber: "Nambari ya Simu",
    role: "Jukumu",
    actions: "Vitendo",
    view: "Tazama",
    edit: "Hariri",
    activate: "Wezesha",
    deactivate: "Zima",
    operator: "Mchezaji",
    supplier: "Mtoa Huduma",
    active: "Imewezeshwa",
    deactivated: "Imezimwa",
    activatedSuccessfully: "Kituo cha ununuzi kimewezeshwa kwa mafanikio",
    deactivatedSuccessfully: "Kituo cha ununuzi kimezimwa kwa mafanikio",
  
    factoryActivatedSuccessfully: "Kiwanda kimewezeshwa kwa mafanikio",
    factoryDeactivatedSuccessfully: "Kiwanda kimezimwa kwa mafanikio",
    factoryRegisteredSuccessfully: "Kiwanda kimesajiliwa kwa mafanikio",
    
    // Buying Station Details specific translations
    userDetails: "Maelezo ya Mtumiaji",
    name: "Jina",
    provinceState: "Mkoa/Jimbo",
    villageCityTown: "Kijiji/Mji/Mji mdogo",
    country: "Nchi",
    associatedFarms: "Mashamba Yenye Uhusiano",
    back: "Rudi",
    addPurchaseOrder: "Ongeza Agizo la Ununuzi",
    cherryCollection: "Mkusanyiko wa Cherry",
    addCherryCollection: "Ongeza Mkusanyiko wa Cherry",
    search: "Tafuta",
    orderId: "Kitambulisho cha Agizo",
    farmFarmer: "Shamba / Mkulima",
    coffeeSpeciesVariety: "Aina / Tofauti ya Kahawa",
    quantityPrice: "Kiasi / Bei",
    delete: "Futa",
    
    // Processing Batch specific translations
    addProcessingBatch: "Ongeza Kundi la Usindikaji",
    batchId: "Kitambulisho cha Kundi",
    lots: "Vipande",
    greenCoffeeOut: "Kahawa Ijani Imetoka",
    startEndDate: "Tarehe ya Kuanza / Tarehe ya Mwisho",
    
    // Associated Farms specific translations
    addFarm: "Ongeza Shamba",
    farmNameAndId: "Jina la Shamba & Kitambulisho",
    addressOfProduction: "Anwani ya Uzalishaji",
    areaHa: "Eneo (ha)",
    type: "Aina",
    eudrDeforestationStatus: "Hali ya Ukatili wa Misitu ya EUDR",
    eudrDeforestationStatusTT: "Hali ya Tathmini ya Hatari ya Ukatili wa Misitu ya EUDR",
    zeroNegligibleProbability: "Uwezekano wa Sifuri / Kidogo",
    assessments: "Tathmini",
    riskAssessment: "Tathmini ya Hatari",
    compliant: "Inalingana",
    nonCompliant: "Hailingani",
    pending: "Inasubiri",
    dateOfSubmission: "Tarehe ya Uwasilishaji",
    dateOfExpiry: "Tarehe ya Mwisho wa Matumizi",
    selectFarms: "Chagua Mashamba",
    reviewSelection: "Kagua Uchaguzi",
    next: "Inayofuata",
    reviewMappingPrompt: "Umechagua mashamba {count}. Thibitisha ili kuyaunganisha na kituo hiki cha ununuzi.",
    confirmMapping: "Thibitisha Unganisho",
    farmsMappedSuccess: "Mashamba yamefanikiwa kuunganishwa",
    farmsMappedError: "Imeshindwa kuunganisha mashamba",
    owner: "Mmiliki",

    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Ingiza Data kwa Wingi",
        importButton: "Ingiza Maagizo ya Ununuzi kwa Wingi",
        title: "Uingizaji wa Data ya Maagizo ya Ununuzi kwa Wingi",
        // Upload tab
        templateNote: "Pakua na utumie violezo vilivyo hapa chini kuingiza maagizo ya ununuzi kwa wingi.",
        selectTemplate: "Chagua Kiolezo",
        templateXls: "Ingiza Muundo wa XLS",
        downloadXls: "Pakua Muundo wa XLS",
        selectFile: "Chagua faili ili Kupakia Data",
        dropHere: "au buruta na acha hapa",
        fileUploaded: "Faili imepakiwa kwa mafanikio.",
        importantNote: "Kumbukumbu Muhimu",
        importantNoteDetail:
          "Tafadhali tumia violezo vilivyotolewa hapo juu kwa upakiaji wa wingi. Miundo mingine itasababisha kushindwa.",
        unsupportedFileFormat: "Muundo huu wa faili hautumiki.",
        invalidFileFormat: "Tafadhali pakia faili halali ya .xlsx, .xls au .csv ukitumia kiolezo kilichotolewa.",
        templateErrorIntro:
          "Faili iliyopakiwa hailingani na kiolezo kinachohitajika. Pakua kiolezo na ujaribu tena.",
        importingTitle: "Inaingiza...",
        importingNote:
          "Faili ulizopakia zinashughulikiwa kwa sasa.\nTutakuarifu mara faili zitakapopakiwa kwa mafanikio.",
        // Result page
        importCompleted: "Uingizaji Umekamilika",
        recordsReadyToImport: "rekodi tayari kuingizwa",
        tabTotalRecords: "Jumla ya Rekodi",
        tabSuccess: "Mafanikio",
        tabIssues: "Matatizo",
        filterAll: "Zote",
        filterSuccess: "Mafanikio",
        issuesDetected: "Matatizo Yamegunduliwa",
        issuesDetectedHeading: "Tofauti imegunduliwa:",
        issuesDetectedDescription:
          "Baadhi ya safu zina matatizo ya data (mf., tarehe ya ununuzi isiyo sahihi, mkulima, shamba au data ya kahawa isiyojulikana). Tafadhali kagua na usuluhishe kabla ya kuwasilisha mwisho.",
        deleteRowsWithIssues: "Futa safu zenye Tofauti za Data",
        // Table headers
        purchaseDate: "Tarehe ya Ununuzi",
        farmer: "Mkulima",
        farm: "Shamba",
        buyingStation: "Kituo cha Ununuzi",
        coffeeQuantityQuality: "Kiasi na Ubora wa Kahawa",
        plantation: "Upandaji miti",
        coffeeSpecies: "Aina za Kahawa",
        coffeeVariety: "Aina ya Kahawa",
        coffeeType: "Aina ya Kahawa",
        coffeeCherryQuantity: "Kiasi cha Cherry ya Kahawa",
        coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
        pricePerKg: "Bei Kwa Kg",
        receiptNo: "Receipt No",
        lotId: "Kitambulisho cha Loti",
        photos: "Picha",
        // Actions / dialogs
        purchaseOrder: "Agizo la Ununuzi",
        detailsTitle: "Maelezo ya Agizo la Ununuzi",
        editRecord: "Hariri rekodi",
        deleteRecord: "Futa rekodi",
        deleteRecordConfirm:
          "Je, una uhakika unataka kufuta rekodi hii? Kitendo hiki hakiwezi kutenduliwa.",
        deleteDiscrepancyConfirm:
          "Je, una uhakika unataka kufuta safu zote {count} zenye matatizo? Kitendo hiki hakiwezi kutenduliwa.",
        cancelImportTitle: "Ghairi Uingizaji",
        cancelImportConfirm:
          "Je, una uhakika unataka kughairi uingizaji huu? Rekodi zilizothibitishwa hazitaweza kuingizwa tena.",
        cancelImportConfirmBtn: "Ghairi Uingizaji",
        importConfirm: "Ingiza rekodi {count} halali sasa?",
        recordUpdatedSuccess: "Rekodi imesasishwa kwa mafanikio.",
        recordsDeletedSuccess: "Rekodi zimefutwa kwa mafanikio.",
        importCancelledSuccess: "Uingizaji umeghairiwa kwa mafanikio.",
        genericError: "Hitilafu imetokea. Tafadhali jaribu tena.",
        noDataFound: "Hakuna data iliyopatikana.",
        // Edit dialog
        selectFactory: "Chagua Kiwanda",
        selectFarmer: "Chagua Mkulima",
        selectFarm: "Chagua Shamba",
        selectPlantation: "Chagua Upandaji miti",
        submit: "Wasilisha",
        addImage: "Ongeza Picha",
        addedBy: "Imeongezwa na",
        close: "Funga",
        // Success dialog
        successDialogTitle: "Ujumbe wa Mafanikio",
        importedSuccessfully: "Maagizo ya ununuzi {count} yameingizwa kwa mafanikio.",
        // History
        historyFile: "Jina la Faili",
        historyImportedOn: "Imeingizwa Tarehe",
        historyEmpty: "Bado hakuna historia ya uingizaji wa wingi.",
        statusValidating: "Inathibitisha",
        statusSuccess: "Imeingizwa",
        statusCancelled: "Imeghairiwa",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "Tarehe ya ununuzi si sahihi.",
        errorMissingPurchaseDate: "Tarehe ya ununuzi inakosekana.",
        errorMissingMemberId: "Member ID inakosekana.",
        errorInvalidMemberIdFormat: "Muundo wa Member ID si sahihi. Inatarajiwa: Jina la Mkulima - Jina la Kituo cha Ununuzi - Kitambulisho cha Shamba.",
        errorInvalidFarmerName: "Mkulima hakupatikana katika shirika lako.",
        errorInvalidBuyingStationName: "Kituo cha ununuzi hakikupatikana katika shirika lako.",
        errorInvalidFarm: "Shamba halikupatikana katika shirika lako.",
        errorMissingQuantity: "Kiasi cha cherry ya kahawa kinakosekana.",
        errorInvalidQuantity: "Kiasi cha cherry ya kahawa lazima kiwe nambari kubwa kuliko sifuri.",
        errorMissingQuality: "Ubora wa cherry ya kahawa unakosekana.",
        errorInvalidQuality: "Ubora wa cherry ya kahawa haukutambuliwa.",
        errorMissingPrice: "Bei inakosekana.",
        errorInvalidPrice: "Bei lazima iwe nambari halali.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Tarehe ya Ununuzi Si Sahihi",
        chipMissingPurchaseDate: "Tarehe ya Ununuzi Inakosekana",
        chipMissingMemberId: "Member ID Inakosekana",
        chipInvalidMemberIdFormat: "Muundo wa Member ID Si Sahihi",
        chipInvalidFarmerName: "Mkulima Si Sahihi",
        chipInvalidBuyingStationName: "Kituo cha Ununuzi Si Sahihi",
        chipInvalidFarm: "Shamba Si Sahihi",
        chipMissingQuantity: "Kiasi Kinakosekana",
        chipInvalidQuantity: "Kiasi Si Sahihi",
        chipMissingQuality: "Ubora Unakosekana",
        chipInvalidQuality: "Ubora Si Sahihi",
        chipMissingPrice: "Bei Inakosekana",
        chipInvalidPrice: "Bei Si Sahihi",

      },
    },
    processingBatchBulkImport: {
      bulkImport: "Ingiza Makundi ya Usindikaji kwa Wingi",
      title: "Uingizaji wa Makundi ya Usindikaji kwa Wingi",
      instructions: "Pakia faili ya CSV au XLSX ukitumia kiolezo hapa chini. Kila safu inaunda kundi moja la usindikaji.",
      downloadCsv: "Pakua kiolezo cha CSV",
      downloadXlsx: "Pakua kiolezo cha XLSX",
      selectFile: "Chagua faili ya CSV au XLSX",
      rowsParsed: "Safu {count} tayari kuingizwa.",
      import: "Ingiza",
      imported: "Imeingiza {created} ya {total} kundi(makundi).",
      failed: "Safu {failed} zimeshindwa.",
      rowError: "Safu {row}",
      emptyFile: "Faili haina safu za data.",
      missingColumns: "Safu wima zinazohitajika hazipo: {columns}",
      noBuyingStation: "Hakuna kituo cha ununuzi kilichochaguliwa.",
      validating: "Inathibitisha safu…",
      total: "Jumla",
      valid: "Sahihi",
      invalid: "Si Sahihi",
      all: "Zote",
      statusValid: "Sahihi",
      statusInvalid: "Si Sahihi",
      issues: "Matatizo",
      back: "Rudi",
      importValid: "Ingiza safu {count} sahihi",
      done: "Imekamilika",
      rowCol: "Safu",
      startDateCol: "Tarehe ya Usindikaji",
      purchaseOrdersCol: "Misimbo ya Ununuzi",
      processTypeCol: "Aina ya Usindikaji",
      gradeCol: "Daraja",
      seasonCol: "Msimu",
      statusCol: "Hali",
      purchaseDateCol: "Tarehe ya Ununuzi",
      processDateCol: "Tarehe ya Usindikaji",
      parchmentCol: "Parchment (Kg)",
      bagsCol: "Mifuko",
      vehiclePlateCol: "Nambari ya Gari",
      harvestedCol: "Imevunwa",
      pulpedCol: "Imepigwa Pulp",
      washedCol: "Imeosha",
      dryingStartedCol: "Ukaushaji Ulianza",
      movedToStoreCol: "Imehifadhiwa",
      templateNote: "Pakua na utumie violezo vilivyo hapa chini kuingiza makundi ya usindikaji kwa wingi.",
      selectTemplate: "Chagua Kiolezo",
      templateCsv: "Ingiza Muundo wa CSV",
      templateXls: "Ingiza Muundo wa XLS",
      downloadCsvFormat: "Pakua Muundo wa CSV",
      downloadXls: "Pakua Muundo wa XLS",
      importingTitle: "Uingizaji wa Makundi ya Usindikaji kwa Wingi",
      importingNote: "Faili uliyoipakia inashughulikiwa kwa sasa.\nUsibofye ghairi, usifunge wala usionyeshe upya ukurasa huu ili kuepuka usumbufu.",
      importantNote: "Kumbukumbu Muhimu",
      importantNoteDetail: "Tafadhali tumia violezo vilivyotolewa hapo juu kwa uingizaji wa makundi ya usindikaji kwa wingi. Miundo mingine itasababisha kushindwa.",
      invalidFileFormat: "Tafadhali pakia faili halali ya .csv, .xlsx au .xls ukitumia kiolezo kilichotolewa.",
      unsupportedFileFormat: "Muundo huu wa faili hautumiki.",
      templateErrorIntro: "Faili iliyopakiwa hailingani na kiolezo kinachohitajika. Pakua kiolezo na ujaribu tena.",
      importCompleted: "Uingizaji Umekamilika",
      tabTotalRecords: "Jumla ya Rekodi",
      tabSuccess: "Mafanikio",
      tabIssues: "Matatizo",
      filterAll: "Zote",
      filterSuccess: "Mafanikio",
      issuesDetected: "Matatizo Yamegunduliwa",
      issuesDetectedHeading: "Matatizo Yamegunduliwa:",
      issuesDetectedDescription: "Baadhi ya safu zina matatizo ya data (mf., tarehe zinazokosekana, aina ya usindikaji isiyojulikana, au thamani isiyo sahihi ya parchment). Tafadhali kagua na usuluhishe kabla ya kuwasilisha mwisho.",
      deleteRowsWithIssues: "Futa safu zenye matatizo",
      editRecord: "Hariri rekodi",
      deleteRecord: "Futa rekodi",
      deleteRecordConfirm: "Je, una uhakika unataka kufuta rekodi hii? Kitendo hiki hakiwezi kutenduliwa.",
      deleteDiscrepancyConfirm: "Je, una uhakika unataka kufuta safu zote {count} zenye matatizo? Kitendo hiki hakiwezi kutenduliwa.",
      cancelImportTitle: "Ghairi Uingizaji",
      cancelImportConfirm: "Je, una uhakika unataka kughairi uingizaji huu? Rekodi zilizothibitishwa hazitaweza kuingizwa tena.",
      cancelImportConfirmBtn: "Ghairi Uingizaji",
      importConfirm: "Ingiza rekodi {count} halali sasa?",
      recordUpdatedSuccess: "Rekodi imesasishwa kwa mafanikio.",
      recordsDeletedSuccess: "Rekodi zimefutwa kwa mafanikio.",
      importCancelledSuccess: "Uingizaji umeghairiwa kwa mafanikio.",
      genericError: "Hitilafu imetokea. Tafadhali jaribu tena.",
      noDataFound: "Hakuna data iliyopatikana.",
      editRecordTitle: "Hariri Rekodi",
      submit: "Wasilisha",
      detailsTitle: "Maelezo ya Kundi la Usindikaji",
      close: "Funga",
      successDialogTitle: "Ujumbe wa Mafanikio",
      importedSuccessfully: "Rekodi {count} za makundi ya usindikaji zimeingizwa kwa mafanikio.",
      historyFile: "Jina la Faili",
      historyImportedOn: "Imeingizwa Tarehe",
      historyEmpty: "Bado hakuna historia ya uingizaji wa wingi.",
      statusValidating: "Inathibitisha",
      statusSuccess: "Imeingizwa",
      statusCancelled: "Imeghairiwa",
      errorCodePurchaseDateRequired: "Tarehe ya ununuzi inahitajika.",
      errorCodeInvalidPurchaseDate: "Muundo wa tarehe ya ununuzi hautambuliwi.",
      errorCodeProcessDateRequired: "Tarehe ya usindikaji inahitajika.",
      errorCodeInvalidProcessDate: "Muundo wa tarehe ya usindikaji hautambuliwi.",
      errorCodeUnknownProcessType: "Aina ya usindikaji haijatambuliwa.",
      errorCodeNoOrdersForDate: "Hakuna maagizo ya ununuzi yaliyopatikana kwa tarehe hiyo.",
      errorCodeParchmentInvalid: "Thamani ya parchment (Kg) si sahihi.",
      errorCodeParchmentExceedsCherry: "Parchment (Kg) haiwezi kuzidi jumla ya kiasi cha cherry ya kahawa.",
      errorCodeInvalidData: "Sehemu moja au zaidi zina data isiyo sahihi.",
      chipPurchaseDateRequired: "Tarehe ya Ununuzi Inahitajika",
      chipInvalidPurchaseDate: "Tarehe ya Ununuzi Si Sahihi",
      chipProcessDateRequired: "Tarehe ya Usindikaji Inahitajika",
      chipInvalidProcessDate: "Tarehe ya Usindikaji Si Sahihi",
      chipUnknownProcessType: "Aina ya Usindikaji Haijulikani",
      chipNoOrdersForDate: "Hakuna Maagizo kwa Tarehe Hii",
      chipParchmentInvalid: "Parchment Si Sahihi",
      chipParchmentExceedsCherry: "Parchment Inazidi Cherry",
      chipInvalidData: "Data Si Sahihi",
    },
    greenCoffee: {
      bulkImport: {
        importButton: "Ingiza Kahawa Ijani kwa Wingi",
        title: "Uingizaji wa Data ya Kahawa Ijani kwa Wingi",
        breadcrumb: "Muhtasari wa Kahawa > Usagaji wa Kavu",
        tabImport: "Ingiza",
        tabHistory: "Historia",
        templateNote:
          "Pakua na utumie violezo vilivyo hapa chini kuingiza kahawa ijani kwa wingi.",
        selectTemplate: "Chagua Kiolezo",
        templateXls: "Ingiza Muundo wa XLS",
        importingTitle: "Uingizaji wa Data ya Kahawa Ijani kwa Wingi",
        importingNote:
          "Faili uliyoipakia inashughulikiwa kwa sasa.\nUsibofye ghairi, usifunge wala usionyeshe upya ukurasa huu ili kuepuka usumbufu.",
        importCompleted: "Uingizaji Umekamilika",
        tabTotalRecords: "Jumla ya Rekodi",
        tabSuccess: "Mafanikio",
        tabFailed: "Zilizoshindwa",
        tabIssues: "Matatizo",
        tabDataDiscrepancies: "Tofauti za Data",
        filterAll: "Zote",
        filterSuccess: "Mafanikio",
        filterIssues: "Matatizo",
        issuesDetectedHeading: "Matatizo Yamegunduliwa:",
        issuesDetectedDescription:
          "Baadhi ya loti zina matatizo ya data (mf., nambari ya matokeo isiyo sahihi, nambari ya matokeo isiyokuwepo kwenye mfumo). Tafadhali kagua na usuluhishe kabla ya kuwasilisha mwisho.",
        deleteLotsWithDataDiscrepancies: "Futa Loti zenye Tofauti za Data",
        lotId: "Kitambulisho cha Loti",
        lotIdAndOutturn: "Kitambulisho cha Loti na Matokeo",
        grower: "Mkulima",
        coffeeType: "Aina ya Kahawa",
        grossAndNetWeight: "Uzito Jumla na Uzito Halisi",
        issuesDetected: "Matatizo Yamegunduliwa",
        issueOutturnNumberMismatchTitle: "Nambari ya matokeo hailingani:",
        issueOutturnNumberMismatchDescription:
          "Matokeo haya hayalingani na rekodi zozote za Uwasilishaji wa Ngozi zilizopo. Tafadhali hakikisha Nambari ya Matokeo iliunganishwa kwa mkono katika ngazi ya Kiwanda kabla ya kupakia tena.",
        issueDuplicateOutturnNumberTitle: "Nambari ya Matokeo Iliyorudiwa:",
        issueDuplicateOutturnNumberDescription:
          "Nambari ya matokeo inaonekana mara nyingi katika hati hii iliyopakiwa.",
        issueMissingOutturnNumberTitle: "Nambari ya Matokeo Inakosekana:",
        issueMissingOutturnNumberDescription:
          "Safu iliyopakiwa haina Nambari ya Matokeo. Kitambulisho cha Matokeo halali na cha kipekee kinahitajika ili kulinganisha rekodi na mfumo wa kiwanda.",
        issueGrowerIdentityMismatchTitle: "Tofauti ya Utambulisho wa Mkulima:",
        issueGrowerIdentityMismatchDescription:
          "Nambari ya matokeo imesajiliwa katika mfumo wetu chini ya Mkulima {mobileGrowerName}, lakini faili iliyopakiwa inaimpa {xlsGrowerName}. Uandishi upya wa data umezuiwa.",
        issueMissingGrowerCredentialsTitle: "Vitambulisho vya Mkulima Vinakosekana:",
        issueMissingGrowerCredentialsDescription:
          "Rekodi haina Jina la Mkulima au Kitambulisho cha Mkulima. Sehemu hizi za data ni za lazima ili kuthibitisha umiliki wa kiwanda kabla ya kundi kupatanishwa.",
        editRecord: "Hariri rekodi",
        deleteRecord: "Futa rekodi",
        downloadXls: "Pakua Muundo wa XLS",
        selectFile: "Chagua faili ili Kupakia Data",
        dropHere: "au buruta na acha hapa",
        importantNote: "Kumbukumbu Muhimu",
        importantNoteDetail:
          "Tafadhali tumia violezo vilivyotolewa hapo juu kuingiza kahawa ijani kwa wingi. Miundo mingine itasababisha kushindwa.",
        invalidFileFormat: "Tafadhali pakia faili halali ya .xlsx au .xls ukitumia kiolezo kilichotolewa.",
        unsupportedFileFormat: "Muundo huu wa faili hautumiki.",
        importFailed: "Uingizaji Umeshindwa",
        importFailedIntro:
          "Faili haikuweza kuingizwa. Angalia muundo wa kiolezo na data ya safu, kisha ujaribu tena.",
        templateErrorIntro:
          "Faili iliyopakiwa hailingani na kiolezo kinachohitajika. Pakua kiolezo cha XLS na ujaribu tena.",
        tryAgain: "Jaribu Tena",
        errorDetails: "Maelezo",
        historyEmpty: "Bado hakuna historia ya uingizaji wa wingi.",
        // Validation review / import flow
        validationSummaryTitle: "Muhtasari wa Uthibitishaji",
        recordsReadyToImport: "rekodi tayari kuingizwa",
        editRecordTitle: "Hariri Rekodi",
        growerCode: "Msimbo wa Mkulima",
        growerName: "Jina la Mkulima",
        greenBeansTotal: "Uzito wa Ingizo Pamoja na Mifuko (Kg)",
        selectedCount: "zilizochaguliwa",
        deleteSelected: "Futa Zilizochaguliwa",
        deleteRecordConfirm:
          "Je, una uhakika unataka kufuta rekodi hii? Kitendo hiki hakiwezi kutenduliwa.",
        deleteSelectedConfirm:
          "Je, una uhakika unataka kufuta rekodi {count} zilizochaguliwa? Kitendo hiki hakiwezi kutenduliwa.",
        deleteDiscrepancyConfirm:
          "Je, una uhakika unataka kufuta loti zote {count} zenye tofauti za data? Kitendo hiki hakiwezi kutenduliwa.",
        cancelImportTitle: "Ghairi Uingizaji",
        cancelImportConfirm:
          "Je, una uhakika unataka kughairi uingizaji huu? Rekodi zilizothibitishwa hazitaweza kuingizwa tena.",
        cancelImportConfirmBtn: "Ghairi Uingizaji",
        importConfirm: "Ingiza rekodi {count} halali sasa?",
        recordUpdatedSuccess: "Rekodi imesasishwa kwa mafanikio.",
        recordsDeletedSuccess: "Rekodi zimefutwa kwa mafanikio.",
        importCancelledSuccess: "Uingizaji umeghairiwa kwa mafanikio.",
        importSuccess: "Uingizaji umekamilika kwa mafanikio.",
        genericError: "Hitilafu imetokea. Tafadhali jaribu tena.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Data Isiyo Sahihi:",
        issueInvalidDataDescription:
          "Sehemu moja au zaidi zina data isiyo sahihi. Tafadhali zikague na uzisahihishe.",
        errorCodeOutturnMismatch:
          "Nambari hii ya matokeo hailingani na rekodi yoyote ya uwasilishaji wa ngozi iliyopo.",
        errorCodeOutturnMissing: "Nambari ya matokeo inakosekana.",
        errorCodeOutturnDuplicate:
          "Nambari hii ya matokeo imerudiwa katika faili au tayari ipo kwenye mfumo.",
        errorCodeGrowerMismatch:
          "Jina/msimbo wa mkulima hailingani na uwasilishaji wa ngozi uliosajiliwa.",
        errorCodeGrowerMissing: "Jina au msimbo wa mkulima unakosekana.",
        errorCodeInvalidData: "Sehemu moja au zaidi zina data isiyo sahihi.",
        // History table
        historyFile: "Jina la Faili",
        historyImportedOn: "Imeingizwa Tarehe",
        historyUploadedBy: "Imepakiwa na",
        historyCreatedDate: "Tarehe ya Kuundwa",
        historyTotalRecords: "Jumla ya Rekodi",
        historyErrorRecords: "Rekodi zenye Hitilafu",
        // Bulk import status labels
        statusValidating: "Inathibitisha",
        statusSuccess: "Imeingizwa",
        statusCancelled: "Imeghairiwa",
        // Edit record dialog
        editFieldId: "Kitambulisho",
        inputWeightWithBags: "Uzito wa Ingizo Pamoja na Mifuko",
        qualityControl: "Udhibiti wa Ubora",
        submit: "Wasilisha",
        noMillingOutputs: "Hakuna maelezo ya matokeo ya usagaji.",
        millingCleanCoffee: "Kahawa Safi (Maelezo ya Matokeo ya Usagaji)",
        millingBags: "Mifuko (Maelezo ya Matokeo ya Usagaji)",
        millingPockets: "Mifukoni (Maelezo ya Matokeo ya Usagaji)",
        millingWeight: "Uzito (Maelezo ya Matokeo ya Usagaji)",
        millingBulkOutturn: "Matokeo ya Jumla (Maelezo ya Matokeo ya Usagaji)",
        millingRatio: "Uwiano (Maelezo ya Matokeo ya Usagaji)",
        // Detail dialog
        detailsTitle: "Maelezo ya Kahawa Ijani",
        outturnNo: "Nambari ya Matokeo",
        close: "Funga",
        // Success dialog
        successDialogTitle: "Ujumbe wa Mafanikio",
        importedSuccessfully:
          "Rekodi {count} za kahawa ijani zimeingizwa kwa mafanikio.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Nambari ya Matokeo Hailingani",
        chipOutturnMissing: "Nambari ya Matokeo Inakosekana",
        chipOutturnDuplicate: "Nambari ya Matokeo Iliyorudiwa",
        chipGrowerMismatch: "Tofauti ya Utambulisho wa Mkulima",
        chipGrowerMissing: "Vitambulisho vya Mkulima Vinakosekana",
        chipInvalidData: "Data Isiyo Sahihi",
      },
      processGreenCoffee: "Chakata Kahawa Ijani",
      addedBy: "Imeongezwa na",
      selectProductType: "Chagua Aina ya Bidhaa",
      processDate: "Tarehe ya Mchakato",
      selectProcessingBatch: "Chagua Kundi la Usindikaji",
      lotIdAndDate: "Kitambulisho cha Kundi na Tarehe",
      typeAndQuantity: "Aina na Kiasi",
      supplier: "Mtoaji",
      outturnNumber: "Nambari ya Matokeo",
      totalInputQuantity: "Jumla ya Kiasi cha Ingizo (kg)",
      qualityControl: "Udhibiti wa Ubora",
      airHumidity: "Unyevu wa Hewa (thamani kwa %)",
      density: "Msongamano (kg/cm3)",
      greenCoffeeQualityScore: "Alama ya Ubora wa Kahawa Ijani",
      batchProduction: "Uzalishaji wa Kundi",
      unsortedGreenBeans: "Maharage ya Kijani Yasiyopangwa (kg)",
      batchProductionDensity: "Msongamano wa Uzalishaji wa Kundi (kg/cm3)",
      percentagePrimaryDefect: "Asilimia ya Kasoro ya Msingi",
      percentageSecondaryDefect: "Asilimia ya Kasoro ya Pili",
      greenBeans: "Maharage ya Kijani",
      totalGreenBeans: "Jumla ya Maharage ya Kijani (kg)",
      unitSize: "Ukubwa wa Kitengo (kg)",
      totalBags: "Jumla ya Mifuko",
      leftoverQuantity: "Kiasi Kilichobaki",
      leftoverQuantityDesc: "Kiasi Kilichobaki ni kiasi kilichosalia ambacho hakiwezi kuunda mfuko kamili. Kinawakilisha kiasi kilichosalia baada ya kujaza idadi ya juu zaidi ya vitengo kamili kutoka kwa ugavi wote.",
      expiryDate: "Tarehe ya Mwisho",
      label: "Lebo",
      qualityControlButton: "Udhibiti wa Ubora",
      valueInPercent: "thamani kwa %",
      kgCm3: "kg/cm3",
      complete: "Imekamilika",
      lotIdOutturnNo: "Kitambulisho cha Kundi / Nambari ya Matokeo",
      startDate: "Tarehe ya Kuanza",
      greenBeansQualityGrading: "Ukadiriaji wa Ubora wa Maharage ya Kijani",
      totalQuantity: "Kiasi Jumla",
      quantity: "Kiasi",
      packing: "Ufungaji",
      bag: "Mfuko",
      qualityScore: "Alama ya Ubora",
      noLotsYet: "Bado hakuna loti. Ongeza alama za ubora kutoka kwa mtiririko wa uundaji.",
      lotId: "Kitambulisho cha Kundi",
      percentage: "Asilimia",
      createQualityGrade: "Unda Daraja la Ubora",
      finishGrading: "Maliza Ukadiriaji",
      finishGradingDesc: "Ukishamaliza huwezi kukadiria loti hii tena. Taka itakokotolewa kiotomatiki baada ya kukamilika.",
      finishGradingButton: "Maliza Ukadiriaji",
      addNewQualityGrade: "Ongeza Daraja Jipya la Ubora",
      totalGreenBeansExceeded: "Kiasi kilichopimwa hawezi kuzidi Jumla ya Maharage ya Kijani.",
      lotIdAlreadyExists: "Kitambulisho hiki cha loti tayari kinatumika. Tumia kitambulisho tofauti cha loti.",
      toAddRecord: "kuongeza rekodi.",
      registeredSuccess: "Kahawa Ijani imesajiliwa kwa mafanikio",
      exportNotImplemented: "Usafirishaji haujatekelezwa",
      processingBatchRequired: "Kundi la usindikaji linahitajika",
      outturnAvailable: "Nambari ya matokeo inapatikana",
      outturnExists: "Nambari hii ya matokeo tayari ipo. Tafadhali ingiza nambari ya kipekee.",
      totalGreenBeansRequired: "Jumla ya maharage ya kijani inahitajika",
      enterHere: "Ingiza hapa",
      viewTitle: "Ukadiriaji wa Ubora wa Maharage ya Kijani",
      parchmentInformation: "Maelezo ya Ngozi",
      processInformation: "Maelezo ya Mchakato",
      greenBeansInformation: "Maelezo ya Maharage ya Kijani",
      traceabilityLabel: "Lebo ya Ufuatiliaji",
      waste: "Taka",
      downloadLabel: "Pakua Lebo",
      startCupping: "Anza Kuonja",
      cuppingHistory: "Historia ya Kuonja",
      noDataFound: "Hakuna data iliyopatikana.",
      noParchmentBatches: "Hakuna mabundi ya ngozi yaliyounganishwa.",
      noQualityGrades: "Hakuna alama za ubora zilizorekodiwa.",
      batchId: "Kitambulisho cha Kundi",
      species: "Aina",
      variety: "Aina",
      process: "Mchakato",
      batchRating: "Ukadiriaji wa Kundi",
      humidity: "Unyevu",
      totalCoffeeCherryQty: "Kiasi cha Cherry ya Kahawa",
      weightBeforeProcessing: "Uzito kabla ya Usindikaji",
      numberOfBags: "Idadi ya Mifuko",
      externalId: "Kitambulisho cha Nje",
      qrCode: "Msimbo wa QR",
      latestCuppingScore: "Alama ya Kuonja ya Hivi Karibuni",
      totalWaste: "Taka Jumla",
      close: "Funga",
      unitSizeKgBag: "Ukubwa wa Kitengo (kg/mfuko)",
      grade: "Daraja",
      selectGrade: "Chagua daraja",
      quantityRequired: "Kiasi kinahitajika",
      quantityMustBePositive: "Kiasi lazima kiwe zaidi ya 0",
      unitSizeRequired: "Ukubwa wa kitengo unahitajika",
      unitSizeMustBePositive: "Ukubwa wa kitengo lazima uwe zaidi ya 0",
      gradeRequired: "Daraja linahitajika",
      labelRequired: "Lebo inahitajika",
      cupping: "Kuonja",
      cuppingInformation: "Maelezo ya Kuonja",
      cupperName: "Jina la Mwonjaji",
      cuppingDate: "Tarehe ya Kuonja",
      enterCupperName: "Ingiza jina la mwonjaji",
      attachFiles: "Ambatisha Faili",
      selectFilesToUpload: "Chagua Faili za Kupakia Data",
      orDragAndDrop: "au buruta na acha hapa",
      lightRoast: "Ukaangaji Mwepesi",
      roastingTime: "Muda wa Ukaangaji",
      roastingTemperature: "Halijoto ya Ukaangaji",
      qualities: "Sifa",
      uniformity: "Usawa",
      cleanCup: "Kikombe Safi",
      sweetness: "Utamu",
      overall: "Kwa Ujumla",
      defects: "Kasoro",
      finalScore: "Alama ya Mwisho",
      sessionDetails: "Maelezo ya kikao",
      noCuppingHistory: "Hakuna historia ya kuonja kwa kahawa hii ijani.",
      cuppingDataSaved: "Data ya kuonja imehifadhiwa.",
      date: "Tarehe",
      roast: "Kukaanga",
      score: "Alama",
    },
    confirmDialog: {
      delete: {
        title: "Futa Kituo cha Ununuzi",
        message: "Je, una uhakika unataka kufuta kituo hiki cha ununuzi?",
        confirmBtn: "Futa",
      },
      activate: {
        title: "Amilisha",
        message: "Je, una uhakika unataka kuweka hiki {entity} hai?",
        confirmBtn: "Amilisha",
      },
      deactivate: {
        title: "Zima",
        message: "Je, una uhakika unataka kuzima hiki {entity}?",
        confirmBtn: "Zima",
      },
    },
    
    registerNewFactory: "Sajili Kiwanda Kipya",
    selectHowYouWantToProceed: "Chagua Njia Unavyotaka Kuendelea",
    single: "Moja",
    multiple: "Nyingi",
    user: "Mtumiaji",
    createNewFactory: "Unda Kiwanda Kipya",
    factoryName: "Jina la Kiwanda",
    factoryNumber: "Nambari ya Kiwanda",
    firstName: "Jina la Kwanza",
    lastName: "Jina la Mwisho",
    primaryEmailAddress: "Anwani ya Barua Pepe ya Msingi",
    submit: "Wasilisha",
    downloadTemplate: "Unduh Model",
    templateInfo: "Pakua faili la kiolezo ili kuona muundo unaohitajika kwa usajili wa wingi.",
    templateFormat: "Tafadhali toa faili katika muundo wa CSV.",
    selectFileToUpload: "Chagua faili ili kupakia data",
    uploadFileOrDragAndDrop: "au buruta na uachie hapa",
  },
};
